/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-insurances
 * crm-screener-insurances
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PalSubmissionListEntryLeadAllOfAssignmentsInner
 */
export interface PalSubmissionListEntryLeadAllOfAssignmentsInner {
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    user_id: string;
    /**
     * 
     */
    role: PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum;
}


/**
 * @export
 */
export const PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON',
} as const;
export type PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum = typeof PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum[keyof typeof PalSubmissionListEntryLeadAllOfAssignmentsInnerRoleEnum];


/**
 * Check if a given object implements the PalSubmissionListEntryLeadAllOfAssignmentsInner interface.
 */
export function instanceOfPalSubmissionListEntryLeadAllOfAssignmentsInner(value: object): value is PalSubmissionListEntryLeadAllOfAssignmentsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('user_id' in value) || value['user_id'] === undefined) return false;
    if (!('role' in value) || value['role'] === undefined) return false;
    return true;
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSON(json: any): PalSubmissionListEntryLeadAllOfAssignmentsInner {
    return PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PalSubmissionListEntryLeadAllOfAssignmentsInner {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerToJSON(json: any): PalSubmissionListEntryLeadAllOfAssignmentsInner {
    return PalSubmissionListEntryLeadAllOfAssignmentsInnerToJSONTyped(json, false);
}

export function PalSubmissionListEntryLeadAllOfAssignmentsInnerToJSONTyped(value?: PalSubmissionListEntryLeadAllOfAssignmentsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'user_id': value['user_id'],
        'role': value['role'],
    };
}

